import { Auth } from 'aws-amplify';

export async function getCurrentUserEmail() {
  try {
    const session = await Auth.currentAuthenticatedUser();
    return session?.signInUserSession?.idToken?.payload?.email || null;
  } catch {
    return null;
  }
}

export async function stampBatchWithActorEmail(
  items,
  fieldName = 'updatedByEmail',
) {
  const email = await getCurrentUserEmail();
  if (!email) return items;
  return items.map((item) => ({ ...item, [fieldName]: email }));
}
